<template>
  <div class="main">
    <Loading v-if="isLoading"></Loading>
    <div class="main__block">
      <div class="flex f-col jcs aic" v-if="cusType == 'nnp'">
        <div class="title">填寫資料</div>
        <div class="flex f-col jcs aic">
          <input
            v-model="tempUser.name"
            type="text"
            class="input__input"
            placeholder="請輸入姓名"
          />
        </div>
        <div class="flex f-col jcs aic">
          <input
            ref="BDinput"
            v-model="tempUser.birthday"
            type="text"
            class="input__input"
            :max="toDay"
            @focus="setBDinputToDate"
            placeholder="請輸入生日(西元年/月/日)"
          />
        </div>
        <div class="flex f-col jcs aic">
          <input
            v-model="tempUser.mobile"
            type="text"
            class="input__input"
            placeholder="請輸入手機號碼"
            disabled
          />
        </div>
      </div>
      <div v-if="registrations.length > 0" class="title">
        <span v-if="customer.cusname">{{customer.cusname}}</span>
        <span v-else-if="newpatient.name">{{newpatient.name}}</span>
        您好，您已預約...
      </div>
      <div class="table-wrap mob-show">
        <table v-if="registrations.length > 0">
          <tbody>
            <tr v-for="reg in registrations" :key="reg.id">
              <td>
                <div v-if="isCancelDeadline(reg.date)" style="text-align: center;">
                  {{ online_cancel_day }}日內預約<br>已無法取消
                </div>
                <div v-else @click="cancelResv(reg.id)" class="btn btn-sm">
                  取消
                </div>
              </td>
              <td>
                <span
                  >日期：{{ reg.date }}({{ showWeekDay(reg.date) }})
                  {{
                    calCheckinTime(reg.date, reg.sch_time, reg.checkin)
                  }}</span
                >
                <span class="strong">項目：{{ reg.sch_note }}</span>
                <span>
                  <span v-if="clinic.name === '樂衍'">您預約的服務人員：{{ reg.staff.name }}({{ reg.staff.sex | gender }})</span>
                  <span v-else-if="dental_is_enable == '2'">
                    <span v-if="reg.sch_note.indexOf('除毛') > -1">
                      醫師：{{ reg.staff.name }}({{ reg.staff.sex | gender }})
                    </span>
                    <span v-else-if="reg.sch_note.indexOf('果酸') > -1">
                      美容師：
                      {{ reg.staff.name }}({{ reg.staff.sex | gender }})
                    </span>
                    <span v-else>
                      醫師：{{ reg.staff.name }}({{ reg.staff.sex | gender }})
                    </span>
                  </span>
                  <span v-else-if="dental_is_enable == '3'">
                    治療師：
                    {{ reg.staff.name }}({{ reg.staff.sex | gender }})
                  </span>
                  <span v-else>
                    醫師：
                    {{ reg.staff.name }}({{ reg.staff.sex | gender }})
                  </span>
                </span>
                <div v-if="reg.mgm" class="referral-card" style="margin-top: 0;margin-bottom: 0;">
                  <div class="referral-code-block">
                    <div class="referral-label">推薦碼</div>
                    <div class="referral-code">{{ reg.mgm.referral_code }}</div>
                  </div>
                  <div class="referral-divider"></div>
                  <div class="referral-period-block">
                    <div class="referral-label">活動內容</div>
                    <div class="referral-period">{{ reg.mgm.referee }}</div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="!no_remaining_times && ((registrations.length > 0 && cusType !== 'np') || cusType == 'nnp' || cusType === 'cus')" style="margin-top: 60px;">
        <div class="title" style="text-align: center;">選擇預約項目</div>
        <!-- 輸入推薦碼 愛爾麗x享圈 專用 -->
        <div v-if="showReferralCodeSection" class="flex f-col jcs aic" style="margin-bottom: 20px;">
          <div class="flex f-row jcc aic">
            <div class="flex f-row jcc aic" v-if="referralCodeData.checked && referralCodeData.success">
              <!-- 成功顯示 .referral-card，失敗顯示 input -->
              <div class="referral-card">
                <div class="referral-code-block">
                  <div class="referral-label">推薦碼</div>
                  <div class="referral-code">{{ referralCode }}</div>
                </div>
                <div class="referral-divider"></div>
                <div class="referral-period-block">
                  <div class="referral-label">活動期間</div>
                  <div class="referral-period">{{ referralCodeData.res_data.campaign_info.start }} 至 {{ referralCodeData.res_data.campaign_info.end }}</div>
                </div>
              </div>
              <a
                class="link-btn"
                @click.prevent="resetReferralCode"
                style="margin-left: 10px;"
              >
                刪除
              </a>
            </div>
            <div class="flex f-row jcs aic mob-flex-col" style="gap:10px !important;" v-else>
              <div class="input-wrapper">
                <input
                  v-if="!referralCodeData.success"
                  name="referralCode"
                  v-model="referralCode"
                  type="text"
                  class="input__input mob-m-0"
                  placeholder="請輸入推薦碼"
                  style="margin-right: 10px;"
                />

                <!-- 清除按鈕：當 referralCode 有值時才顯示 -->
                <div
                  v-if="referralCode && (!referralCodeData.checked || !referralCodeData.success)"
                  class="clear-btn"
                  @mousedown.prevent.stop="resetReferralCode"
                >
                  <p>×</p>
                </div>
              </div>
              <!-- 驗證按鈕或刪除連結 -->
              <div
                class="btn confirm"
                style="width: auto;"
                @click="submitReferralCode"
              >
                驗證
              </div>
            </div>
          </div>

          <!-- 顯示成功訊息 -->
          <span
            v-if="referralCodeData.success"
            class="strong"
            style="color: #ffffff; margin: 10px 0 0;"
          >
            🎉 {{ referralCodeData.res_data.campaign_info.reward.referee }}
          </span>

          <!-- 顯示錯誤訊息 -->
          <span
            v-else-if="referralCodeData.checked"
            class="strong"
            style="color: #e60000; background-color: #ffdddd; padding: 4px 10px; border-radius: 4px; margin-top: 10px;letter-spacing: 1px;"
          >
            {{ referralCodeData.message }}
          </span>
        </div>
        
        <div class="flex f-row jcc aic services">
          <div v-for="(room, index) in filterRooms" :key="index">
            <button
              @click="chooseService(room)"
              class="btn btn-lg"
              :disabled="referralCodeData.checked && !referralCodeData.success"
            >
              {{ room.name }}
            </button>
          </div>
          <button
            v-for="booking in bookings" :key="`booking_${booking.id}`"
            :disabled="referralCodeData.checked && !referralCodeData.success"
            class="btn btn-lg" :style="{display: rooms.find(item => item.no == booking.room_no) ? 'flex' : 'none'}"
            @click="chooseService(rooms.find(item => item.no == booking.room_no), booking.name, booking)">
              {{ booking.name }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Loading from '../components/Loading.vue';
import airleeClinicList from '../config/airleeClinicList';
export default {
  name: 'ChooseService',
  components: {
    Loading,
  },
  data() {
    return {
      settings: {
        online_resv_np: 0,
      },
      showRoom: 
      [
        '果酸',
        '除毛',
        '雷美',
        '雷美一',
        '增生門診',
        '植牙',
        '牙周',
        '止鼾諮詢門診',
        '一般治療',
        '矯正門診',
        '假牙贗復',
        '洗牙',
        '檢查',
        '塗氟',
        '矯正諮詢',
        '植牙諮詢',
      ],
      registrations: {},
      tempUser: {
        name: '',
        birthday: '',
        mobile: ''
      },
      referralCode: '',
      referralCodeData: {
        checked: false,
        success: false,
        message: '',
        res_data: {
          campaign_info: {
            reward: {
              referee: ''
            }
          }
        }
      },
      isHqOp: false,
    };
  },
  filters: {
    gender(num = 0) {
      if (num === 0) {
        return '女';
      } else if (num === 1) {
        return '男';
      } else {
        return '';
      }
    },
  },
  methods: {
    showWeekDay(date) {
      const week = ['日', '一', '二', '三', '四', '五', '六'];
      const d = new Date(date);
      return week[d.getDay()];
    },
    setBDinputToDate() {
      this.$refs.BDinput.setAttribute('type', 'date');
    },
    checkBDDate() {
      return new Date(this.tempUser.birthday) > new Date('1911-01-01');
    },
    checkClinic() {
      if (this.$route.query.clinicCode) {
        localStorage.setItem('clinicCode', this.$route.query.clinicCode);
      } else {
        alert('診所代碼錯誤,請重新登入！');
        this.backToLogin();
      }
    },
    getOnlineResvNp() {
      const clinicCode = this.$route.query.clinicCode;
      const onlineResvNp = localStorage.getItem(`online_resv_np_${clinicCode}`);
      if (onlineResvNp) {
        this.settings.online_resv_np = JSON.parse(onlineResvNp);
      } else {
        this.settings.online_resv_np = 0;
      }
    },
    backToLogin() {
      const clinicCode = this.$route.query.clinicCode;
      this.$router.push(`/login?clinicCode=${clinicCode}`);
    },
    isCancelDeadline(date) {
      // 若online_cancel_day為0，則不鎖定取消
      if (this.online_cancel_day === 0) {
        return false;
      }
      // 判斷date-今天得出的天數，是否大於等於online_cancel_day
      const today = new Date();
      const dd = today.getDate();
      const mm = today.getMonth() + 1; //January is 0!
      const yyyy = today.getFullYear();
      const dateStr = `${date} 00:00:00`;
      const todayStr = `${yyyy}-${mm}-${dd} 00:00:00`;
      const diff = Math.floor((new Date(dateStr) - new Date(todayStr)) / (1000 * 60 * 60 * 24));
      
      if (diff <= this.online_cancel_day) {
        return true;
      } else {
        return false;
      }
    },
    async cancelResv(regsn) {
      try {
        const clinicCode = this.$route.query.clinicCode;
        if (confirm('確定要取消預約？')) {
          const fd = new FormData();
          fd.append('Authorization', this.token);
          fd.append('_method', 'delete');
          fd.append('system_by', 'online');
          await this.$store.dispatch('resvModule/cancelResv', {
            data: {
              fd: fd,
              regsn: regsn,
            },
            clinicCode,
          });
          this.registrations = JSON.parse(
            localStorage.getItem(`registrations_${clinicCode}`)
          );
          if(this.registrations.length == 0 && this.cusType == 'np') {
            this.backToLogin();
          }
        }
      } catch (e) {
        const message = e.response.data.msg;
        alert(message);
      }
    },
    calCheckinTime(ddate, sch_time, checkin = 0) {
      const dd = ddate.split('-');
      const y = dd[0];
      const m = dd[1];
      const d = dd[2];

      const tt = sch_time.split(':');
      const h = tt[0];
      const mm = tt[1];
      let dt = new Date(y, m, d, h, mm, 0);
      dt.setMinutes(dt.getMinutes() - checkin);

      const hour = this.padLeft(dt.getHours(), 2, '0');
      const min = this.padLeft(dt.getMinutes(), 2, '0');
      const checkinTime = `${hour}:${min}`;
      return checkinTime;
    },
    padLeft(str, lenght, padstr = '0') {
      str = '' + str;
      return str.length >= lenght
        ? str
        : new Array(lenght - str.length + 1).join(padstr) + str;
    },
    formValidate() {
      return new Promise((resolve, reject) => {
        if(this.tempUser.name.length < 1) {
          reject('請輸入姓名');
        }
        if(this.tempUser.birthday == '' || !this.checkBDDate()) {
          reject('生日未輸入或格式錯誤(西元年/月/日)');
        }
        if(this.tempUser.mobile == '' || this.tempUser.mobile.length !== 10) {
          reject('手機號碼格式錯誤');
        }
        resolve();
      })
    },
    async chooseService(room, medBeauty = null, medBooking = null) {
      const clinicCode = this.$route.query.clinicCode;
      await this.$store.dispatch('authModule/setNnp', { nnp: this.tempUser, clinicCode, });
      try {
        if(this.cusType == 'nnp'){
          await this.formValidate();
        }
        await this.$store.dispatch('resvModule/setRoom', { data: room, clinicCode, });
        await this.$store.dispatch('resvModule/setMed', { data: undefined, clinicCode, });
        await this.$store.dispatch('resvModule/setMedPart', { data: undefined, clinicCode, });
        await this.$store.dispatch('resvModule/setMedProblem', { data: undefined, clinicCode, });
        if (room.name == '除毛' && !medBooking) { // 膚適美 only
          await this.$store.dispatch('resvModule/setNote', { data: '除毛', clinicCode, });
          this.$router.push(`/choose-part?clinicCode=${clinicCode}`);
        } else if (medBeauty == '雷射' && medBooking) { // 膚適美 OR 木木日安 only
          await this.$store.dispatch('resvModule/setMed', { 
            data: {
              type: '雷射',
              id: medBooking.id,
              name: '',
            }, 
            clinicCode,
          });
          await this.$store.dispatch('resvModule/setBooking', { data: medBooking, clinicCode, });
          this.$router.push(`/choose-laser?clinicCode=${clinicCode}`);
        } else if (medBooking) {
          // 有子預約項目
          await this.$store.dispatch('resvModule/setMed', { 
            data: {
              type: medBooking.name,
              id: medBooking.id,
              name: medBooking.name,
            }, 
            clinicCode,
          });
          await this.$store.dispatch('resvModule/setBooking', { data: medBooking, clinicCode, });
          this.$router.push(`/choose-resv-item?clinicCode=${clinicCode}`);
        } else {
          // 無子預約項目直接預約診間
          await this.$store.dispatch('resvModule/setTime', {
            data: {
              schlen: room.schlen,
              checkin: room.checkin,
            },
            clinicCode,
          });
          await this.$store.dispatch('resvModule/setNote', { data: room.name, clinicCode, });
          this.$router.push(`/choose-time?clinicCode=${clinicCode}`);
        }
      } catch (e) {
        alert(e);
      }
    },
    async submitReferralCode() {
      try {
        if (!this.referralCode) {
          alert('請輸入推薦碼');
          return;
        }
        // 驗證推薦碼
        const { data } = await this.$store.dispatch('mgmModule/verifyReferralCode', {
          nhicode: this.$route.query.clinicCode,
          referral_code: this.referralCode,
          cusmob: this.tempUser.mobile || this.customer.cusmob,
        });
        this.referralCodeData = {
          checked: true,
          success: data.success,
          message: data.message || '',
          res_data: data.res_data || {},
          referral_code: this.referralCode
        };
        // 模擬 API 驗證
        // if (this.referralCode === 'Pp2rui') {
        //   this.referralCodeData = {
        //     success: true,
        //     message: '推薦碼驗證查詢成功',
        //     res_data: {
        //       merchant_id: '9',
        //       referral_info: {
        //         cusname: '張雅筑',
        //         cusmob: '0932345671'
        //       },
        //       campaign_info: {
        //         id: '50',
        //         name: '美麗傳承計劃：這一次，換我帶妳變美',
        //         start: '2025-07-08',
        //         end: '2025-12-31',
        //         reward: {
        //           referral: '每推薦一位好友,獲得 200 點',
        //           referee: '首次療程 8 折優惠'
        //         }
        //       },
        //       is_valid: {
        //         res: true,
        //         msg: '推薦碼符合和獎勵條件',
        //         text: '此推薦碼的活動期間為 2025-07-08~2025-12-31，若超過此期間則無法擁有活動權益'
        //       }
        //     },
        //     referral_code: this.referralCode
        //   }
        //   this.referralCodeData.checked = true;
        // } else {
        //   this.referralCodeData = {
        //     success: false,
        //     message: '無指定商戶存取權限或指定商戶不存在',
        //     res_data: {}
        //   };
        //   this.referralCodeData.checked = true;
        // }
        // 將推薦碼資料存入 localStorage
        await this.$store.dispatch('mgmModule/setReferralCodeData', {
          data: this.referralCodeData,
          clinicCode: this.$route.query.clinicCode
        });
        
      } catch (e) {
        alert(e.message);
        this.resetReferralCode();
        console.error(e);
      }
    },
    async resetReferralCode() {
      this.referralCode = '';
      this.referralCodeData = {
        checked: false,
        success: false,
        message: '',
        res_data: {}
      };
      await this.$store.dispatch('mgmModule/setReferralCodeData', {
        data: this.referralCodeData,
        clinicCode: this.$route.query.clinicCode
      });
    }
  },
  computed: {
    ...mapGetters(['isLoading', 'tokenByC']),
    ...mapGetters('authModule', [
      'roomsByC', 
      'clinicByC', 
      'dentalIsEnableByC', 
      'customerByC', 
      'newpatientByC',
      'bookingsByC',
      'resvHoursByC',
      'onlineCancelDay',
      'onlineLimits',
      'mgmIsEnableByC',
    ]),
    ...mapGetters('resvModule', ['resvsByC']),
    resvs() {
      const clinicCode = this.$route.query.clinicCode;
      return this.resvsByC(clinicCode);
    },
    token() {
      const clinicCode = this.$route.query.clinicCode;
      return this.tokenByC(clinicCode);
    },
    rooms() {
      const clinicCode = this.$route.query.clinicCode;
      return this.roomsByC(clinicCode);
    },
    clinic() {
      const clinicCode = this.$route.query.clinicCode;
      return this.clinicByC(clinicCode);
    },
    online_cancel_day() {
      const clinicCode = this.$route.query.clinicCode;
      return this.onlineCancelDay(clinicCode);
    },
    online_limits() {
      const clinicCode = this.$route.query.clinicCode;
      return this.onlineLimits(clinicCode);
    },
    no_remaining_times() {
      let no_remaining_times = false;
      if (this.online_limits && this.online_limits.length > 0) {
        // 檢查array內是否任一筆有item.times-items-used > 0 (剩餘次數)
        no_remaining_times = this.online_limits.some(item => item.used >= item.times);
      }
      return no_remaining_times;
    },
    hasMed() {
      let hasMed = false;
      hasMed = this.rooms.some(item => {
        if (item.disable_resv == 0 && (item.name.indexOf('雷美') > -1 || item.name.indexOf('雷美一') > -1)) {
          return true;
        }
      });
      return hasMed;
    },
    filterRooms() {
      const filterRooms = [];
      this.rooms.forEach((item) => {
        const resvItems = this.bookings.find(b => b.room_no == item.no);
        if(item.disable_resv == 0 && !resvItems) {
          filterRooms.push(item);
        }
      });
      return filterRooms;
    },
    dental_is_enable() {
      const clinicCode = this.$route.query.clinicCode;
      return this.dentalIsEnableByC(clinicCode);
    },
    bookings() {
      const clinicCode = this.$route.query.clinicCode;
      return this.bookingsByC(clinicCode);
    },
    resv_hours() {
      const clinicCode = this.$route.query.clinicCode;
      return this.resvHoursByC(clinicCode);
    },
    customer() {
      const clinicCode = this.$route.query.clinicCode;
      return this.customerByC(clinicCode);
    },
    newpatient() {
      const clinicCode = this.$route.query.clinicCode;
      return this.newpatientByC(clinicCode);
    },
    cusType() {
      let cusType = 'nnp';
      if(Object.keys(this.customer).length > 0) {
        cusType = 'cus';
      }
      if(Object.keys(this.newpatient).length > 0) {
        cusType = 'np';
      }
      return cusType;
    },
    toDay() {
      const today = new Date();
      let dd = today.getDate();
      let mm = today.getMonth() + 1; //January is 0!
      let yyyy = today.getFullYear();
      if (dd < 10) {
        dd = '0' + dd;
      }
      if (mm < 10) {
        mm = '0' + mm;
      } 
      return `${yyyy}-${mm}-${dd}`; 
    },
    isAirleeClinic() {
      // 檢查當前診所是否為愛爾麗
      if (airleeClinicList.some(clinic => clinic.clinic_sn === this.$route.query.clinicCode)) {
        return true;
      }
      return false;
    },
    mgm_is_enable() {
      const clinicCode = this.$route.query.clinicCode;
      return this.mgmIsEnableByC(clinicCode);
    },
    showReferralCodeSection() {
      // 1) 先判斷是否愛爾麗，愛爾麗不受 mgm_is_enable 控制
      if (this.isAirleeClinic) {
        // 2) 愛爾麗：需新患者且不是他院舊客，且開放新患者預約
        return (
          !this.isHqOp &&
          this.cusType === 'nnp' &&
          this.settings.online_resv_np == 1
        );
      }
      // 3) 一般診所：需 MGM 功能開啟 && 需有手機號碼
      return parseInt(this.mgm_is_enable, 10) === 1 && this.customer.cusmob;
    },
  },
  async created() {
    try {
      await this.getOnlineResvNp();
      await this.checkClinic();
      window.scrollTo(0, 0);
      const clinicCode = this.$route.query.clinicCode;
      const fd = new FormData();
      fd.append('Authorization', this.token);
      
      const nnp = JSON.parse(localStorage.getItem(`nnp_${clinicCode}`));
      if(Object.keys(nnp).length > 0 && Object.values(nnp).some(v => v !== '')) {
        const { name, birthday, mobile } = nnp;
        this.tempUser.name = name;
        this.tempUser.birthday = birthday;
        this.tempUser.mobile = mobile;
        // 若為愛爾麗分院，則確認是否為他院舊客
        if (this.isAirleeClinic) {
          this.isHqOp = await this.$store.dispatch('airleeResvModule/checkHqOp', { data: { cusmob: mobile }});
        }
      }

      // 清除推薦碼資料
      this.resetReferralCode();
      
      await this.$store.dispatch('resvModule/getRegistrations', { data: { fd }, clinicCode});
      this.registrations = JSON.parse(localStorage.getItem(`registrations_${clinicCode}`));
    } catch (e) {
      if (e === 'token錯誤') {
        alert('請重新登入');
        this.backToLogin();
      } else if (e !== '初診預約查詢請重新登入') {
        alert(e);
      }
    }
  },
};
</script>
<style>
.services{
  flex-wrap: wrap;
  gap: 15px;
}
</style>
